import { useState, useEffect } from "react";
import { T } from "react-translator-component";
import {
  Box, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Typography,
} from "@mui/material";
import { useAppDispatch } from "../../redux/store";
import { setErrorObj } from "../redux/errorReducer";
import apiServices from "../services/apiServices";
import { convertUserImage } from "../../util/utils";
import AdminPageFrame from "../components/AdminPageFrame";
import LoadingModal from "../../components/LoadingModal";
import ContainerPaper from "../components/ContainerPaper";
import ReadMore from "../components/ReadMore";
import { mngStyles } from "../constants/styles";
import profile from "../../assets/images/profile_img.png";
import PostCardModal from "../components/commentList/PostCardModal";

export default function RejectedCommentList() {
  // 本画面で取得するcommentのstatus一覧
  const statuses = ["Rejected"]

  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [comments, setComments] = useState<any[]>([]);
  const [pagination, setPagination] = useState<any>();
  const [highlightWords, setHighlightWords] = useState<string[]>([]);
  const [modalPost, setModalPost] = useState<any>();

  useEffect(() => {
    getRejectedComments(1);
    getNegativeWords();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getRejectedComments = async (page: number) => {
    const params = {
      status: statuses,
      page: page
    }

    try {
      setIsLoading(true);
      const res = await apiServices.getComments(params);
      if (page > 1) {
        setComments([...comments, ...res.comments]);
      } else {
        setComments(res.comments);
      }
      setPagination(res.pagination);
    } catch (error: any) {
      dispatch(setErrorObj(error))
    } finally {
      setIsLoading(false)
    }
  };

  const handleMore = async () => {
    if (!pagination?.next_page || pagination?.next_page < 2) return
    await getRejectedComments(pagination.next_page);
  };

  const getNegativeWords = async () => {
    try {
      setIsLoading(true);
      const res = await apiServices.getNegativeWords();
      setHighlightWords(res.negative_words.map((ng: any) => ng.word))
    } catch (error) {
      dispatch(setErrorObj(error))
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenPostModal = async (postId: number | undefined) => {
    if (!postId) return

    try {
      setIsLoading(true);
      const res = await apiServices.getPostSlimData(postId);
      const resComments = await apiServices.getPostCommnets(postId, ["Approved", "Rejected"])
      setModalPost({
        ...res.post,
        // コメント一覧への導線を確保する
        enable_comments: true,
        // コメント数をpendingのcommentsも込みにする
        comments_count: resComments.post_comments.comments_count
      });
    } catch (error: any) {
      dispatch(setErrorObj(error))
    } finally {
      setIsLoading(false)
    }
  };

  return (
    <AdminPageFrame>
      <LoadingModal visible={isLoading} />

      <ContainerPaper>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell colSpan={2}>{T("mng_negative_words_rejected_comments")}</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {comments.map((comment: any) => (
                <TableRow key={comment.id}>
                  <TableCell component="th" scope="row" onClick={() => handleOpenPostModal(comment.post_id)}>
                    <Box display="flex" alignItems="center">
                      <img
                        src={comment.user?.image ? convertUserImage(comment?.user?.image) : profile}
                        alt={"userimg"}
                        style={{
                          width: 70,
                          height: 60,
                          marginBottom: 20,
                          borderRadius: "50%",
                        }}
                      />
                      <Box marginLeft={2} sx={{ width: "100%" }}>
                        <Typography
                          className="truncate"
                          variant="subtitle1"
                          style={mngStyles.desTable}
                        >
                          {comment.user?.nickname}
                        </Typography>

                        <Typography
                          className="truncate"
                          variant="subtitle1"
                          style={mngStyles.desTable}
                        >
                          {comment.content}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <ReadMore open={pagination?.next_page > 0} onClick={() => handleMore()} />
        </TableContainer>
      </ContainerPaper>

      <PostCardModal
        post={modalPost}
        highlightWords={highlightWords}
        onClose={() => setModalPost(undefined)}
        addCommnetStatus={statuses}
      />
    </AdminPageFrame>
  );
}
